import { Link } from "react-router-dom";
import { Award, Download, Share2, ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";
import { useCertificate, CertificateArt, formatDate } from "@/components/CertificateKit";

const COLORS = ["var(--bt-primary)", "var(--bt-sage-deep)", "var(--bt-sage)", "#C9B98F"];

export default function Celebration({ open, onOpenChange, c }) {
  const { user } = useAuth();
  const { settings } = useSite();
  const kit = useCertificate(c.slug, c.title);
  const name = `The ${user?.first_name || ""} Family`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] w-[94vw] max-w-2xl min-w-0 overflow-y-auto overflow-x-hidden rounded-[28px] border-bt-border bg-bt-bg p-6 sm:p-8" data-testid="celebration-dialog">
        <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
          {Array.from({ length: 28 }).map((_, i) => (
            <span key={i} className="confetti" style={{ left: `${(i * 37) % 100}%`, background: COLORS[i % COLORS.length], animationDelay: `${(i % 7) * 0.18}s` }} />
          ))}
        </div>
        <div className="relative text-center">
          <span className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-bt-primary text-bt-bg"><Award size={30} /></span>
          <DialogTitle className="font-heading text-3xl text-bt-heading sm:text-4xl">You did it!</DialogTitle>
          <DialogDescription className="mx-auto mt-3 max-w-md text-base text-bt-text">{c.completion_message}</DialogDescription>
        </div>
        <div className="relative mt-6">
          <CertificateArt c={c} name={name} date={formatDate()} kit={kit} />
        </div>
        <div className="relative mt-6 grid gap-3 sm:grid-cols-2">
          <button onClick={kit.share} disabled={kit.busy} className="btn-primary" data-testid="celebration-share-button"><Share2 size={18} /> {kit.busy ? "Creating..." : "Share certificate"}</button>
          <button onClick={kit.download} disabled={kit.busy} className="btn-secondary" data-testid="celebration-download-button"><Download size={18} /> Download image</button>
        </div>
        <div className="relative mt-4 flex flex-col items-center justify-center gap-2 text-sm sm:flex-row sm:gap-6">
          <Link to={`/challenge/${c.slug}/certificate`} className="font-semibold text-bt-primary underline" data-testid="celebration-edit-name-link">Change the name on it</Link>
          <a href={settings.community.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-semibold text-bt-primary underline" data-testid="celebration-community-link">
            Share your win in the community <ArrowUpRight size={14} />
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
